/**
 * Converts a given number of bytes into a human-readable string representation.
 * @param {number} bytes - The number of bytes to be formatted.
 * @returns {string} A human-readable representation of the input bytes.
 */
export function formatBytes(bytes) {
  /**
   * Array representing size units.
   * @type {string[]}
   */
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];

  // If the input is zero bytes, return '0 Bytes'
  if (bytes === 0) return "0 Bytes";

  /**
   * Index representing the appropriate size unit to use.
   * @type {number}
   */
  const i = Math.floor(Math.log(bytes) / Math.log(1024));

  // If the size unit is 'Bytes', return the bytes directly
  if (i === 0) return `${bytes} ${sizes[i]}`;

  /**
   * Formatted string representing the size in the appropriate unit.
   * @type {string}
   */
  return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
}
